// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareDevices4K_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2H24V18H0V2ZM2 4H22V16H2V4Z" class="svg-bg"/>
  <path d="M16 20H8L7 22H17L16 20ZM10.4102 6.5V10.9141H11.25V12.0664H10.4102V13.502H9.00391V12.0664H5.95215V10.8604C6.22233 10.5576 6.50228 10.2272 6.79199 9.86914 7.08171 9.50781 7.36165 9.13672 7.63184 8.75586 7.90202 8.375 8.15267 7.99251 8.38379 7.6084 8.61816 7.22103 8.81673 6.85156 8.97949 6.5H10.4102ZM7.33398 10.9141H9.00391V8.46777C8.88997 8.67936 8.76628 8.89421 8.63281 9.1123 8.49935 9.32715 8.35938 9.54036 8.21289 9.75195 8.06641 9.96029 7.91829 10.1637 7.76855 10.3623 7.61882 10.5576 7.47396 10.7415 7.33398 10.9141ZM17.8203 13.502H15.8281L13.7871 10.46C13.748 10.4014 13.6862 10.2728 13.6016 10.0742H13.5771V13.502H12V6.5H13.5771V9.81055H13.6016C13.6406 9.7194 13.7057 9.58919 13.7969 9.41992L15.7305 6.5H17.6104L15.1689 9.83984 17.8203 13.502Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareDevices4K is a generated icon component.
 */
let IconHardwareDevices4K = IconHardwareDevices4K_1 = class IconHardwareDevices4K extends IconBaseElement {
    render() {
        return html `${IconHardwareDevices4K_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareDevices4K.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareDevices4K = IconHardwareDevices4K_1 = __decorate([
    customElement('zui-icon-hardware-devices-4-k')
], IconHardwareDevices4K);
export { IconHardwareDevices4K };
